import React from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

export function getActivityCandidates(activity, metadata = {}) {
  const ids = Array.isArray(metadata.candidate_ids) ? metadata.candidate_ids : [];
  const names = Array.isArray(metadata.candidate_names) ? metadata.candidate_names : [];
  const entries = ids.map((id, index) => ({ id, name: names[index] }));
  const directId = activity.entity_type === "candidate" ? activity.entity_id : metadata.candidate_id;
  if (directId) entries.unshift({
    id: directId,
    name: metadata.candidate_name || (activity.entity_type === "candidate" ? activity.summary : ""),
  });
  const seen = new Set();
  return entries.filter((candidate) => {
    candidate.id = Number(candidate.id);
    candidate.name = String(candidate.name || "").trim();
    if (!Number.isSafeInteger(candidate.id) || candidate.id <= 0 || !candidate.name || seen.has(candidate.id)) return false;
    seen.add(candidate.id);
    return true;
  });
}

export default function ActivityCandidateText({ text, candidates = [] }) {
  const value = String(text || "");
  const parts = [];
  let offset = 0;
  while (offset < value.length) {
    const searchOffset = offset;
    const match = candidates
      .map((candidate) => ({ ...candidate, index: value.indexOf(candidate.name, searchOffset) }))
      .filter((candidate) => candidate.index >= 0)
      .sort((a, b) => a.index - b.index || b.name.length - a.name.length)[0];
    if (!match) { parts.push(value.slice(offset)); break; }
    parts.push(value.slice(offset, match.index));
    parts.push(
      <Box key={`${match.index}:${match.id}`} component={Link}
        to={`/candidates?candidateId=${encodeURIComponent(match.id)}&tab=details`}
        onClick={(event) => event.stopPropagation()}
        sx={{ color: "#3451F4", textDecoration: "none", "&:hover": { textDecoration: "underline" }, "&:focus-visible": { outline: "2px solid #9C4FFF", outlineOffset: 2 } }}>
        {match.name}
      </Box>
    );
    offset = match.index + match.name.length;
  }
  return <>{parts}</>;
}
